<!--P033-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'KitchenManage'})">中央厨房维护</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">中央厨房详情</div>
    </div>
    <!--基本信息-->
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">基本信息</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">中央厨房编号</div>
      <div class="cs_radius_lg txt_info_search">{{search.num}}</div>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">中央厨房名称</div>
      <input v-model="search.name" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">负责人</div>
      <input v-model="search.contactName" class="cs_input cs_radius_lg edtxt_info_search ui_margin_left_30" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_left">联系方式</div>
      <input v-model="search.mobileNo" class="cs_input cs_radius_lg edtxt_info_search" placeholder="非必填">
      <br>
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm">所在地址</div>
      <input v-model="search.address" class="cs_input cs_radius_lg edtxt_info_search cs_margin_top_sm width_468 ui_margin_left_44" placeholder="非必填">
      <div class="cs_title_primary cs_text_default type_info_search cs_margin_top_sm cs_margin_left">启用状态</div>
      <div class="cs_radius_lg txt_info_search cs_margin_top_sm">{{KITCHEN_STATUS[search.isStop]}}</div>
    </div>
    <!--配送中心接入管理-->
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">配送中心接入管理</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">接入配送中心</div>
      <web-select :options="search.dcList"
                  @option-key="updateDc"
                  v-model="search.dcName"
                  class="cs_input cs_radius_lg edtxt_info_search"></web-select>
    </div>
    <div class="div_operation_table cs_align_center" style="margin-top:400px;">
      <button @click="btnCancel" class="cs_btn cs_btn_sm ui_btn_ghost_blue"
              type="button">取消
      </button>
      <button @click="btnSave" class="cs_btn cs_btn_sm ui_btn_blue ui_margin_left_88"
              type="button">保存
      </button>
    </div>
    <div class="div_bottom"></div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select"
  import {KITCHEN_STATUS} from "../../assets/utils/constants"
  import WhParameter from "../../assets/csui/parameter/WhParameter"
  export default {
    name: "KitchenDetail",
    components: {WebSelect,SearchSelect},
    data: function () {
      return {
        search: {
          num: "",
          name: "",
          contactName: "",
          mobileNo: "",
          address: "",
          isStop: "",
          dcId: 0,
          dcName: "",
          dcList: [],
        },
        KITCHEN_STATUS: KITCHEN_STATUS
      }
    },
    created: function () {
      this.showDetail();
      this.showDc();
    },
    mounted: function() {
    },
    methods: {
      showDetail(){
        this.$ajax.kitchen.acquire.bind(this)(this.$route.query.id,(data) => {
          this.search.num = data.data.kitchenNum;
          this.search.name = data.data.kitchenName;
          this.search.contactName = data.data.contactName;
          this.search.mobileNo = data.data.mobileNo;
          this.search.address = data.data.kitchenAddress;
          this.search.isStop = data.data.isStop;
          this.search.dcId = this.isEmpty(data.data.dcName)?"":data.data.dcId;
          this.search.dcName = this.isEmpty(data.data.dcName)?"":data.data.dcName;
        }, (data) => {
        }, true)
      },
      btnSave(){
        try {
          WhParameter.verifyNotEmpty(this.search.name, "中央厨房名称");
        }catch (e) {
          this.$toast(e.message);
          return;
        }
        if(this.isEmptySelect(this.search.dcId)){
          this.$toast("请选择接入配送中心");
          return;
        }
        this.$ajax.kitchen.modify.bind(this)(this.search,(data) => {
          this.$toast("保存成功");
          this.$router.replace({name:'KitchenManage'});
        }, (data) => {
        }, true)
      },
      btnCancel(){
        this.$router.go(-1);
      },
      showDc(){
        this.$ajax.common.listDistributionCenter.bind(this)((data) => {
          //显示列表
          let array = [];
          for (let i = 0; i < data.data.length; i++) {
            array.push({
              key: data.data[i].id,
              value: data.data[i].dcName,
            })
          }
          this.search.dcList = array;
        }, (data) => {
        }, true)
      },
      updateDc(key) {
        this.search.dcId = key;
      },

      failDefault() {
      },
    },
  }
</script>

<style scoped>
  .width_468{
    width: 468px;
  }
</style>



// WEBPACK FOOTER //
// src/page/kitchen/KitchenDetail.vue